/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/
import { useGLTF } from "@react-three/drei";
import React from "react";

export function Airplane(props) {
  const { scene } = useGLTF(
    "/models/airplane/kawaii__cute_flying_robot/scene.gltf"
  );

  // Restore selective material overrides for pink/white scheme
  React.useEffect(() => {
    if (!scene) return;
    scene.traverse((obj) => {
      if (!obj.isMesh || !obj.material) return;
      const materials = Array.isArray(obj.material) ? obj.material : [obj.material];
      const objName = (obj.name || "").toLowerCase();
      materials.forEach((m) => {
        const matName = (m?.name || objName).toLowerCase();
        // Ears and effectively black parts → pink
        const isEar = matName.includes("ear") || objName.includes("ear");
        let isEffectivelyBlack = false;
        if (m.color) {
          const { r, g, b } = m.color;
          isEffectivelyBlack = r < 0.05 && g < 0.05 && b < 0.05;
        }
        if (isEar || isEffectivelyBlack) {
          if (m.color) m.color.set("#ff69b4");
          if (m.emissive) {
            m.emissive.set("#ff69b4");
            m.emissiveIntensity = Math.max(m.emissiveIntensity ?? 0.3, 0.4);
          }
          if ("metalness" in m) m.metalness = 0.1;
          if ("roughness" in m) m.roughness = 0.9;
          return;
        }
        // Green/screen/light/neon parts → white
        if (
          matName.includes("green") ||
          matName.includes("screen") ||
          matName.includes("light") ||
          matName.includes("neon")
        ) {
          if (m.color) m.color.set("#ffffff");
          if (m.emissive) {
            m.emissive.set("#ffffff");
            m.emissiveIntensity = Math.max(m.emissiveIntensity ?? 0.5, 0.6);
          }
          if (m.map) m.map = null;
          return;
        }
        // Fallback: detect green dominant color → white
        if (m.color) {
          const { r, g, b } = m.color;
          const maxRB = Math.max(r, b);
          const greenDominant = g > 0.4 && g - maxRB > 0.12;
          if (greenDominant) {
            m.color.set("#ffffff");
            if (m.emissive) {
              m.emissive.set("#ffffff");
              m.emissiveIntensity = Math.max(m.emissiveIntensity ?? 0.5, 0.6);
            }
            if (m.map) m.map = null;
            return;
          }
        }
        // Otherwise preserve original look
      });
    });
  }, [scene]);

  return (
    <group {...props} dispose={null}>
      <primitive object={scene} />
    </group>
  );
}

useGLTF.preload("/models/airplane/kawaii__cute_flying_robot/scene.gltf");
